import { motion } from "framer-motion";

const float = (dur, delay, dist = 18) => ({
  animate: { y: [0, -dist, 0], rotate: [0, 2, 0] },
  transition: { duration: dur, delay, repeat: Infinity, ease: "easeInOut" },
});

/**
 * Subtle floating background: intertwined US + Haitian flags and classical
 * instruments (violin, cello, piano, flute), kept light. Purely decorative.
 */
export const FloatingDecor = ({ className = "" }) => (
  <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
    <motion.img
      src="/flags.png"
      alt=""
      {...float(11, 0)}
      className="absolute -top-10 -right-6 w-[280px] md:w-[440px] opacity-[0.16] select-none"
    />
    <motion.img
      src="/instruments.png"
      alt=""
      {...float(14, 1.2, 24)}
      className="absolute bottom-0 -left-10 w-[300px] md:w-[460px] opacity-[0.12] select-none"
    />
    <motion.img
      src="/instruments.png"
      alt=""
      {...float(16, 0.6, 14)}
      className="absolute top-1/3 right-1/4 w-[160px] md:w-[220px] opacity-[0.08] select-none hidden md:block"
    />
  </div>
);
